import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import PageHeader from "../components/pageHeader";

const ThankYou = () => {
  return (
    <div>
      <PageHeader title={"Faq's"} />
      <Container className="contact-content">
        <Col xl={{ span: 8, offset: 2 }}>
          <div className="pageContent">
            <h1 className="headline">Task Complete!</h1>

            <div>
              <p>
                Please click the "End Task" button at the bottom of the page to
                submit your responses and proceed to the remainder of the study.
                You may need to click the arrow on the bottom left side to
                expand the pop-out menu.
              </p>
            </div>
          </div>
        </Col>
      </Container>
    </div>
  );
};

export default ThankYou;
